export enum ECookieKey {
	AUTH = 'auth',
	CLIENT_ID = 'client_id',
}
